import * as React from 'react'

export const recruitmentItem = (number: number, copy: string) => {
  return (
    <li className="block__item item">
      <div className="item__inner">
        <div className="item__number">
          <span className="item__label">{number}</span>
        </div>
        <p className="item__text">{copy}</p>
      </div>
    </li>
  )
}

export const recruitmentBlock = () => {
  return (
    <section className="block block--recruit">
    <div className="block__inner container container--m grid--gutter">
      <h2 className="block__title title--s">
        The recruitment process
      </h2>
      <ul className="block__list">
        {recruitmentItem(1, 'Maecenas faucibus mollis interdum. Integer posuere erat a ante venenatis dapibus posuere velit aliquet.')}
        {recruitmentItem(2, 'Maecenas faucibus mollis interdum. Nulla vitae elit libero, a pharetra augue.')}
        {recruitmentItem(3, 'Donec id elit non mi porta gravida at eget metus. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.')}
      </ul>
      <p className="block__disclaimer">
        Refresco believes that the principle of equal opportunities is fundamental to our company's values.
        Our long-held aim is to provide just and fair treatment for all employees. We will not discriminate on
        the grounds of sex, age, disability, marital status, colour, race, religion, ethnic origin, sexual
        orientation or gender reassignment.
      </p>
    </div>
  </section>
  )
}
